// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reservation-errorMessage-U2Nez {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.Reservation-space1-ihic3 {
	margin-bottom: 6px !important;
}
.Reservation-space2-A7AJM {
	margin-bottom: 12px !important;
}
.Reservation-space3-3u5yp {
	margin-bottom: 18px !important;
}
.Reservation-space4-hng_E {
	margin-bottom: 24px !important;
}
.Reservation-space5-KvlRG {
	margin-bottom: 30px !important;
}
.Reservation-space6-RHWSU {
	margin-bottom: 36px !important;
}
.Reservation-space7-PNkDQ {
	margin-bottom: 42px !important;
}
.Reservation-spaceTop8-HLbSs {
	margin-bottom: 48px !important;
}
.Reservation-spaceTop1-RySth {
	margin-top: 6px !important;
}
.Reservation-spaceTop2-YcQPI {
	margin-top: 12px !important;
}
.Reservation-spaceTop3-TDb9m {
	margin-top: 18px !important;
}
.Reservation-spaceTop4-PYCyo {
	margin-top: 24px !important;
}
.Reservation-spaceTop5-IEMSq {
	margin-top: 30px !important;
}
.Reservation-spaceTop6-AgR5F {
	margin-top: 36px !important;
}
.Reservation-spaceTop7-u_9Mp {
	margin-top: 42px !important;
}
.Reservation-spaceTop8-HLbSs {
	margin-top: 48px !important;
}
.Reservation-noMargin-qeDJk {
	margin: 0px !important;
}
.Reservation-padding1-SbinC {
	padding-bottom: 6px !important;
}
.Reservation-padding2-BMOFd {
	padding-bottom: 12px !important;
}
.Reservation-padding3-eCWyt {
	padding-bottom: 18px !important;
}
.Reservation-padding4-_YBdo {
	padding-bottom: 24px !important;
}
.Reservation-padding5-WfzNE {
	padding-bottom: 30px !important;
}
.Reservation-padding6-KwBWO {
	padding-bottom: 36px !important;
}
.Reservation-padding7-e9lHO {
	padding-bottom: 42px !important;
}
.Reservation-paddingTop1-uoELv {
	padding-top: 6px !important;
}
.Reservation-paddingTop2-VFM7A {
	padding-top: 12px !important;
}
.Reservation-paddingTop3-aBUIy {
	padding-top: 18px !important;
}
.Reservation-paddingTop4-QlZFh {
	padding-top: 24px !important;
}
.Reservation-paddingTop5-CQ8kN {
	padding-top: 30px !important;
}
.Reservation-paddingTop6-nwO7Y {
	padding-top: 36px !important;
}
.Reservation-paddingTop7-hAZOu {
	padding-top: 42px !important;
}
.Reservation-noPadding-juhm0 {
	padding: 0px !important;
}
.Reservation-textBold-wjyOK {
	font-weight: 500 !important;
}
.Reservation-textBolder-nxWCR {
	font-weight: 700 !important;
}
.Reservation-textNormal-oWJg5 {
	font-weight: normal !important;
}
.Reservation-spaceBottom20-Ha_QF {
	margin-bottom: 20px;
}
.Reservation-spaceBottom10-IATPS {
	margin-bottom: 10px;
}
.Reservation-marginNone-XI5dq {
	margin: 0;
}
.Reservation-spaceBottom15-VMpzu {
	margin-bottom: 15px;
}
.Reservation-marginTopNone-kq5kj {
	margin-top: 0;
}
.Reservation-spaceTop11-EPmYw {
	margin-top: 11px;
}
.Reservation-spaceTop21-YJw2l {
	margin-top: 21px;
}
.Reservation-spaceTop20-l4cER {
	margin-top: 20px;
}
.Reservation-spaceTop10-FTUp9 {
	margin-top: 10px;
}
/*New Design Text Colors */
.Reservation-textDarkBlue-WQAGZ {
	color: rgb(20, 39, 94) !important;
}
.Reservation-textLightBlue-L20Y4 {
	color: rgb(57, 87, 106) !important;
}
.Reservation-textLightSandleGreen-q_2Wr {
	color: rgb(76, 86, 41) !important;
}
.Reservation-textLightBrown-MtYE5 {
	color: rgb(115, 79, 33) !important;
}
.Reservation-textMediumMaroon-Q3cYq {
	color: rgb(87, 37, 51) !important;
}
.Reservation-textBrown-ptjX3 {
	color: rgb(160, 47, 24) !important;
}
.Reservation-textMaroon-JUlOy {
	color: rgb(155, 49, 67) !important;
}
.Reservation-textDarkBrown-KZWy3 {
	color: rgb(83, 18, 16) !important;
}
.Reservation-textMediumBrown-MIiH4 {
	color: rgb(142, 28, 10) !important;
}
.Reservation-textSkyBlue-ob8BI {
	color: rgb(37, 117, 141) !important;
}
.Reservation-textGray-ERSvu {
	color: rgb(77, 65, 51) !important;
}
/*************************Sidenavigation Styles start******************************************/
a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}
a:hover {
	color: var(--primary-link-foreground);
	cursor: pointer;
}
.Reservation-reservationIcon-XsLnc {
	width: 15px;
	height: 15px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}
/*************************Sidenavigation Styles end******************************************/
/*************************verification Styles start******************************************/
.Reservation-listLayout-MHSah {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
	font-size: 14px !important;
}
.Reservation-labelText-rluTI {
	text-transform: capitalize;
	font-size: 12px;
	border-radius: 30px;
	padding: 8px 15px;
	color: #fff;
}
/*************************verification Styles end******************************************/
.Reservation-sectionTitleLight-x65ha {
	font-size: 16px;
}
.Reservation-mediaContainer-rqTfe {
	display: table;
	position: relative;
}
.Reservation-profileAvatarLink-U6c1p {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}
.Reservation-displayTable-zbFE4 {
	display: table;
	width: 100%;
}
.Reservation-displayTableRow-uVs1x {
	display: table-row;
	width: 100%;
}
.Reservation-displayTableCell-J21AX {
	display: table-cell;
}
.Reservation-noMargin-qeDJk {
	margin: 0;
}
.Reservation-addressWidth-mADk9 {
	width: 47%;
}
.Reservation-logoWidth-qVwRM {
	width: 33%;
}
.Reservation-reservationItemBox-NUgJD {
	position: relative;
	border-radius: 3px;
	margin-bottom: 30px;
	background-color: var(--primary-gray-bg);
}
.Reservation-dateFont-XGIB9 {
	font-size: 16px;
}
.Reservation-alignCenter-j7Sng {
	text-align: center;
}
.Reservation-mediaWidth-NDZhL {
	width: 100%;
}
.Reservation-linkTitle-CoREw {
	font-size: 18px;
}
.Reservation-fontWeight-PHksh {
	font-weight: 700;
}
.Reservation-textWordBreak-uOqtu {
	word-break: break-word;
	font-size: 16px;
	margin: 10px 0 0;
}
.Reservation-dateFontNew-bEufF {
	font-size: 12px;
	word-break: break-word;
}
.Reservation-grid-AZAhC {
	display: grid;
	grid-template-columns: 40% 55%;
	padding: 20px;
	grid-gap: 30px;
}
.Reservation-flex-GWCCN {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 25px;
	   -moz-column-gap: 25px;
	        column-gap: 25px;
}
.Reservation-flexBottom-Alvh_ {
	display: grid;
	grid-template-columns: 33.33% 33.33% 33.33%;
	padding: 20px 0;
	margin: 0 20px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}
.Reservation-streetCss-GJx1J {
	font-size: 16px;
	margin-top: 10px;
}
.Reservation-cityCss-bsBHg {
	font-size: 15px;
	margin-top: 10px;
}
.Reservation-listFlex-bkkSH {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-top: 30px;
}
.Reservation-formControlInput-Tnr9H {
	width: 382px;
	height: 45px;
	border: 1px solid var(--primary-border);
	border-radius: 23px;
}
.Reservation-dateBottom-dqZHc {
	margin-bottom: 16px;
}
.Reservation-chatFlex-P7q9d {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 3px;
	   -moz-column-gap: 3px;
	        column-gap: 3px;
	text-decoration: none !important;
	margin-top: 10px;
}
.Reservation-moreTextSize-suosv {
	font-size: 16px;
}
.Reservation-iconFlex-O2Ggv {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
	-webkit-column-gap: 4px;
	   -moz-column-gap: 4px;
	        column-gap: 4px;
}
.Reservation-textCenter-dW9pH {
	text-align: center;
}
.Reservation-textAlignRight-grutK {
	text-align: right;
}
.Reservation-emailFlex-REupC {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
	gap: 3px;
}
@media screen and (max-width: 991px) {
	.Reservation-tabScreenresolution-QcOXT {
		width: 100%;
		display: block;
	}

	.Reservation-tabAvatarSection-MtNHM {
		width: 60%;
		display: inline-block;
	}

	.Reservation-tabPriceSection-J6T88 {
		display: inline-block;
		width: 40%;
	}

}
.Reservation-confirmationText-PV1Hk {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  margin-bottom: 0;
  padding: 25px 25px 0;
}
.Reservation-modalFooter-KM4_z {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  margin-top: 30px;
  gap: 15px;
  padding: 0 25px 25px;
}
@media screen and (max-width: 767px) {
	.Reservation-responsiveDisplay-MpVZF {
		display: block;
		width: 100%;
	}

	.Reservation-responsiveAvatarSection-b9Qar {
		text-align: left;
		margin-bottom: 8px;
	}

	.Reservation-responsiveAvatarImg-DM0hA {
		display: inline-block;
		width: 20%;
		float: right;
		text-align: center;
	}

	.Reservation-grid-AZAhC {
		grid-template-columns: 100%;
	}

	.Reservation-flexBottom-Alvh_ {
		margin: 0;
		padding: 20px 15px;
		grid-template-columns: 50% 50%;
	}

	.Reservation-alignRightMobile-GNLUP {
		text-align: right;
	}

	.Reservation-textAlignCenterMobile-_BlXL {
		text-align: left;
		margin-left: 8px;
		margin-top: 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/Reservation/Reservation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,+FAA+F;AAC/F;CACC,qCAAqC;CACrC,qBAAqB;AACtB;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAc;KAAd,cAAc;AACf;AAEA,6FAA6F;AAC7F,6FAA6F;AAC7F;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,0BAA0B;AAC3B;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,WAAW;AACZ;AAEA,2FAA2F;AAC3F;CACC,eAAe;AAChB;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;AAEA;CACC,cAAc;CACd,WAAW;AACZ;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,UAAU;AACX;AAEA;CACC,UAAU;AACX;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,wCAAwC;AACzC;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,aAAa;CACb,cAAc;AACf;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,eAAe;CACf,cAAc;CACd,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,uCAAuC;CACvC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,gCAAgC;CAChC,gBAAgB;AACjB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;CACrB,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;CACrB,QAAQ;AACT;AAGA;CACC;EACC,WAAW;EACX,cAAc;CACf;;CAEA;EACC,UAAU;EACV,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;EACrB,UAAU;CACX;;AAED;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;AAEA;CACC;EACC,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,kBAAkB;CACnB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,SAAS;EACT,kBAAkB;EAClB,8BAA8B;CAC/B;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;CACjB;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n/*************************Sidenavigation Styles start******************************************/\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.reservationIcon {\n\twidth: 15px;\n\theight: 15px;\n\tflex-shrink: 0;\n}\n\n/*************************Sidenavigation Styles end******************************************/\n/*************************verification Styles start******************************************/\n.listLayout {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n\tfont-size: 14px !important;\n}\n\n.labelText {\n\ttext-transform: capitalize;\n\tfont-size: 12px;\n\tborder-radius: 30px;\n\tpadding: 8px 15px;\n\tcolor: #fff;\n}\n\n/*************************verification Styles end******************************************/\n.sectionTitleLight {\n\tfont-size: 16px;\n}\n\n.mediaContainer {\n\tdisplay: table;\n\tposition: relative;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n.noMargin {\n\tmargin: 0;\n}\n\n.addressWidth {\n\twidth: 47%;\n}\n\n.logoWidth {\n\twidth: 33%;\n}\n\n.reservationItemBox {\n\tposition: relative;\n\tborder-radius: 3px;\n\tmargin-bottom: 30px;\n\tbackground-color: var(--primary-gray-bg);\n}\n\n.dateFont {\n\tfont-size: 16px;\n}\n\n.alignCenter {\n\ttext-align: center;\n}\n\n.mediaWidth {\n\twidth: 100%;\n}\n\n.linkTitle {\n\tfont-size: 18px;\n}\n\n.fontWeight {\n\tfont-weight: 700;\n}\n\n.textWordBreak {\n\tword-break: break-word;\n\tfont-size: 16px;\n\tmargin: 10px 0 0;\n}\n\n.dateFontNew {\n\tfont-size: 12px;\n\tword-break: break-word;\n}\n\n.grid {\n\tdisplay: grid;\n\tgrid-template-columns: 40% 55%;\n\tpadding: 20px;\n\tgrid-gap: 30px;\n}\n\n.flex {\n\tdisplay: flex;\n\tcolumn-gap: 25px;\n}\n\n.flexBottom {\n\tdisplay: grid;\n\tgrid-template-columns: 33.33% 33.33% 33.33%;\n\tpadding: 20px 0;\n\tmargin: 0 20px;\n\talign-items: center;\n}\n\n.streetCss {\n\tfont-size: 16px;\n\tmargin-top: 10px;\n}\n\n.cityCss {\n\tfont-size: 15px;\n\tmargin-top: 10px;\n}\n\n.listFlex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 30px;\n}\n\n.formControlInput {\n\twidth: 382px;\n\theight: 45px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 23px;\n}\n\n.dateBottom {\n\tmargin-bottom: 16px;\n}\n\n.chatFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 3px;\n\ttext-decoration: none !important;\n\tmargin-top: 10px;\n}\n\n.moreTextSize {\n\tfont-size: 16px;\n}\n\n.iconFlex {\n\tdisplay: flex;\n\talign-items: baseline;\n\tcolumn-gap: 4px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.emailFlex {\n\tdisplay: flex;\n\talign-items: baseline;\n\tgap: 3px;\n}\n\n\n@media screen and (max-width: 991px) {\n\t.tabScreenresolution {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t}\n\n\t.tabAvatarSection {\n\t\twidth: 60%;\n\t\tdisplay: inline-block;\n\t}\n\n\t.tabPriceSection {\n\t\tdisplay: inline-block;\n\t\twidth: 40%;\n\t}\n\n}\n\n.confirmationText {\n  font-size: 16px;\n  line-height: 28px;\n  font-weight: 400;\n  margin-bottom: 0;\n  padding: 25px 25px 0;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n  gap: 15px;\n  padding: 0 25px 25px;\n}\n\n@media screen and (max-width: 767px) {\n\t.responsiveDisplay {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n\n\t.responsiveAvatarSection {\n\t\ttext-align: left;\n\t\tmargin-bottom: 8px;\n\t}\n\n\t.responsiveAvatarImg {\n\t\tdisplay: inline-block;\n\t\twidth: 20%;\n\t\tfloat: right;\n\t\ttext-align: center;\n\t}\n\n\t.grid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.flexBottom {\n\t\tmargin: 0;\n\t\tpadding: 20px 15px;\n\t\tgrid-template-columns: 50% 50%;\n\t}\n\n\t.alignRightMobile {\n\t\ttext-align: right;\n\t}\n\n\t.textAlignCenterMobile {\n\t\ttext-align: left;\n\t\tmargin-left: 8px;\n\t\tmargin-top: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Reservation-errorMessage-U2Nez`,
	"space1": `Reservation-space1-ihic3`,
	"space2": `Reservation-space2-A7AJM`,
	"space3": `Reservation-space3-3u5yp`,
	"space4": `Reservation-space4-hng_E`,
	"space5": `Reservation-space5-KvlRG`,
	"space6": `Reservation-space6-RHWSU`,
	"space7": `Reservation-space7-PNkDQ`,
	"spaceTop8": `Reservation-spaceTop8-HLbSs`,
	"spaceTop1": `Reservation-spaceTop1-RySth`,
	"spaceTop2": `Reservation-spaceTop2-YcQPI`,
	"spaceTop3": `Reservation-spaceTop3-TDb9m`,
	"spaceTop4": `Reservation-spaceTop4-PYCyo`,
	"spaceTop5": `Reservation-spaceTop5-IEMSq`,
	"spaceTop6": `Reservation-spaceTop6-AgR5F`,
	"spaceTop7": `Reservation-spaceTop7-u_9Mp`,
	"noMargin": `Reservation-noMargin-qeDJk`,
	"padding1": `Reservation-padding1-SbinC`,
	"padding2": `Reservation-padding2-BMOFd`,
	"padding3": `Reservation-padding3-eCWyt`,
	"padding4": `Reservation-padding4-_YBdo`,
	"padding5": `Reservation-padding5-WfzNE`,
	"padding6": `Reservation-padding6-KwBWO`,
	"padding7": `Reservation-padding7-e9lHO`,
	"paddingTop1": `Reservation-paddingTop1-uoELv`,
	"paddingTop2": `Reservation-paddingTop2-VFM7A`,
	"paddingTop3": `Reservation-paddingTop3-aBUIy`,
	"paddingTop4": `Reservation-paddingTop4-QlZFh`,
	"paddingTop5": `Reservation-paddingTop5-CQ8kN`,
	"paddingTop6": `Reservation-paddingTop6-nwO7Y`,
	"paddingTop7": `Reservation-paddingTop7-hAZOu`,
	"noPadding": `Reservation-noPadding-juhm0`,
	"textBold": `Reservation-textBold-wjyOK`,
	"textBolder": `Reservation-textBolder-nxWCR`,
	"textNormal": `Reservation-textNormal-oWJg5`,
	"spaceBottom20": `Reservation-spaceBottom20-Ha_QF`,
	"spaceBottom10": `Reservation-spaceBottom10-IATPS`,
	"marginNone": `Reservation-marginNone-XI5dq`,
	"spaceBottom15": `Reservation-spaceBottom15-VMpzu`,
	"marginTopNone": `Reservation-marginTopNone-kq5kj`,
	"spaceTop11": `Reservation-spaceTop11-EPmYw`,
	"spaceTop21": `Reservation-spaceTop21-YJw2l`,
	"spaceTop20": `Reservation-spaceTop20-l4cER`,
	"spaceTop10": `Reservation-spaceTop10-FTUp9`,
	"textDarkBlue": `Reservation-textDarkBlue-WQAGZ`,
	"textLightBlue": `Reservation-textLightBlue-L20Y4`,
	"textLightSandleGreen": `Reservation-textLightSandleGreen-q_2Wr`,
	"textLightBrown": `Reservation-textLightBrown-MtYE5`,
	"textMediumMaroon": `Reservation-textMediumMaroon-Q3cYq`,
	"textBrown": `Reservation-textBrown-ptjX3`,
	"textMaroon": `Reservation-textMaroon-JUlOy`,
	"textDarkBrown": `Reservation-textDarkBrown-KZWy3`,
	"textMediumBrown": `Reservation-textMediumBrown-MIiH4`,
	"textSkyBlue": `Reservation-textSkyBlue-ob8BI`,
	"textGray": `Reservation-textGray-ERSvu`,
	"reservationIcon": `Reservation-reservationIcon-XsLnc`,
	"listLayout": `Reservation-listLayout-MHSah`,
	"labelText": `Reservation-labelText-rluTI`,
	"sectionTitleLight": `Reservation-sectionTitleLight-x65ha`,
	"mediaContainer": `Reservation-mediaContainer-rqTfe`,
	"profileAvatarLink": `Reservation-profileAvatarLink-U6c1p`,
	"displayTable": `Reservation-displayTable-zbFE4`,
	"displayTableRow": `Reservation-displayTableRow-uVs1x`,
	"displayTableCell": `Reservation-displayTableCell-J21AX`,
	"addressWidth": `Reservation-addressWidth-mADk9`,
	"logoWidth": `Reservation-logoWidth-qVwRM`,
	"reservationItemBox": `Reservation-reservationItemBox-NUgJD`,
	"dateFont": `Reservation-dateFont-XGIB9`,
	"alignCenter": `Reservation-alignCenter-j7Sng`,
	"mediaWidth": `Reservation-mediaWidth-NDZhL`,
	"linkTitle": `Reservation-linkTitle-CoREw`,
	"fontWeight": `Reservation-fontWeight-PHksh`,
	"textWordBreak": `Reservation-textWordBreak-uOqtu`,
	"dateFontNew": `Reservation-dateFontNew-bEufF`,
	"grid": `Reservation-grid-AZAhC`,
	"flex": `Reservation-flex-GWCCN`,
	"flexBottom": `Reservation-flexBottom-Alvh_`,
	"streetCss": `Reservation-streetCss-GJx1J`,
	"cityCss": `Reservation-cityCss-bsBHg`,
	"listFlex": `Reservation-listFlex-bkkSH`,
	"formControlInput": `Reservation-formControlInput-Tnr9H`,
	"dateBottom": `Reservation-dateBottom-dqZHc`,
	"chatFlex": `Reservation-chatFlex-P7q9d`,
	"moreTextSize": `Reservation-moreTextSize-suosv`,
	"iconFlex": `Reservation-iconFlex-O2Ggv`,
	"textCenter": `Reservation-textCenter-dW9pH`,
	"textAlignRight": `Reservation-textAlignRight-grutK`,
	"emailFlex": `Reservation-emailFlex-REupC`,
	"tabScreenresolution": `Reservation-tabScreenresolution-QcOXT`,
	"tabAvatarSection": `Reservation-tabAvatarSection-MtNHM`,
	"tabPriceSection": `Reservation-tabPriceSection-J6T88`,
	"confirmationText": `Reservation-confirmationText-PV1Hk`,
	"modalFooter": `Reservation-modalFooter-KM4_z`,
	"responsiveDisplay": `Reservation-responsiveDisplay-MpVZF`,
	"responsiveAvatarSection": `Reservation-responsiveAvatarSection-b9Qar`,
	"responsiveAvatarImg": `Reservation-responsiveAvatarImg-DM0hA`,
	"alignRightMobile": `Reservation-alignRightMobile-GNLUP`,
	"textAlignCenterMobile": `Reservation-textAlignCenterMobile-_BlXL`
};
module.exports = ___CSS_LOADER_EXPORT___;
